// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsTeamsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 23">
    <path
      fill="#5059C9"
      d="M16.35 8.67h5.68c.53 0 .97.43.97.97v5.17c0 1.97-1.6 3.57-3.57 3.57h-.02a3.57 3.57 0 0 1-3.57-3.57V9.18c0-.28.22-.51.5-.51M20.19 7.65a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6"
    />
    <path
      fill="#7B83EB"
      d="M13.02 7.65a3.32 3.32 0 1 0 0-6.65 3.32 3.32 0 0 0 0 6.65M17.46 8.67H8.08a.96.96 0 0 0-.94.98v5.9a5.77 5.77 0 0 0 5.63 5.9 5.77 5.77 0 0 0 5.62-5.9v-5.9a.96.96 0 0 0-.93-.98"
    />
    <path
      fill="#000"
      d="M13.28 8.67v8.26a.94.94 0 0 1-.94.94H7.6a6 6 0 0 1-.45-2.32v-5.9a.96.96 0 0 1 .94-.98z"
      opacity={0.1}
    />
    <path
      fill="#000"
      d="M12.77 8.67v8.78a.94.94 0 0 1-.94.94h-4a7 7 0 0 1-.42-1.03 6 6 0 0 1-.27-1.81v-5.9a.96.96 0 0 1 .94-.98z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.77 8.67v7.75c0 .52-.42.93-.94.94H7.41a6 6 0 0 1-.27-1.81v-5.9a.96.96 0 0 1 .94-.98z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.26 8.67v7.75c0 .52-.43.93-.94.94H7.4a6 6 0 0 1-.27-1.81v-5.9a.96.96 0 0 1 .94-.98z"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M13.28 6.03v1.6l-.26.02-.25-.01a3.32 3.32 0 0 1-2.98-2.55h2.55c.52 0 .94.42.94.94"
      opacity={0.1}
    />
    <path
      fill="#000"
      d="M12.77 6.54v1.1A3.32 3.32 0 0 1 9.96 5.6h1.87c.52 0 .94.41.94.93"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.77 6.54v1.1A3.32 3.32 0 0 1 9.96 5.6h1.87c.52 0 .94.41.94.93"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.26 6.54v1.01a3.3 3.3 0 0 1-2.3-1.95h1.36c.52 0 .93.42.94.94"
      opacity={0.2}
    />
    <path
      fill="url(#ms-teams_svga)"
      d="M1.94 5.6h9.38c.52 0 .94.42.94.94v9.37c0 .52-.42.94-.94.94H1.94A.94.94 0 0 1 1 15.9V6.54c0-.52.42-.94.94-.94"
    />
    <path fill="#fff" d="M9.1 9.17H7.22v5.1h-1.2v-5.1H4.17v-1H9.1z" />
    <defs>
      <linearGradient
        id="ms-teams_svga"
        x1={2.96}
        x2={10.29}
        y1={4.87}
        y2={17.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A62C3" />
        <stop offset={0.5} stopColor="#4D55BD" />
        <stop offset={1} stopColor="#3940AB" />
      </linearGradient>
    </defs>
  </svg>,
  "MsTeams",
);
export default MsTeamsIcon;
